
import { Component, Prop, Vue } from 'vue-property-decorator';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import StackedForm from '../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { Venue } from '../../interfaces/models/Venue';
import { PromoCode } from '../../interfaces/models/PromoCode';
import { InputType } from '../../enums/InputType';
import { venueFilter } from '@/util/helper';

@Component({
  components: { VFormBuilder },
})
export default class DisablePromoCodeForm extends mixins(StackedForm) {
  @Prop({ type: Array, required: true }) public venues!: Venue[];
  @Prop({ type: Array, required: true }) public codes!: PromoCode[];

  get items() {
    return [
      {
        name: 'venue',
        type: InputType.Autocomplete,
        label: 'promo.form.venue',
        rules: 'required',
        itemValue: '_id',
        itemText: 'name',
        items: this.venues,
        filter: venueFilter,
      },
      {
        name: 'promoCodes',
        type: InputType.Select,
        label: 'promo.form.codes',
        rules: 'required',
        items: this.promoItems,
        multiple: true,
      },
    ];
  }

  get promoItems() {
    return this.codes.map((p: PromoCode) => ({ text: p.name, value: p._id }));
  }
}
